import axiosInstance from "../../lib/axiosInstance";
import { AppDispatch } from "../store";
import { sequenceActions } from "../slices/sequence";
import { getErrorMessage } from "../../utils/errorUtils";
import { SequenceResponseDto } from "../../shared/dtos/sequence/SequenceResponseDto";
import { ApiResponseDto } from "../../shared/dtos/common/ApiResponseDto";
import { ApiResponseStatus } from "../../shared/enums/ApiResponseStatus";

export const getSequences =
  () =>
  async (dispatch: AppDispatch): Promise<void> => {
    dispatch(sequenceActions.setLoading());
    try {
      const { data } = await axiosInstance.get<
        ApiResponseDto<SequenceResponseDto[]>
      >("/sequences", {
        headers: { requiresAuth: true },
      });
      if (data.status === ApiResponseStatus.SUCCESS && data.data) {
        dispatch(sequenceActions.setItems(data.data));
      }
    } catch (error) {
      dispatch(sequenceActions.setError(getErrorMessage(error)));
    }
  };
